export enum OptionWashAndTurnEngine {
    NoAction = 'NoAction',
    AutoRegistration = 'AutoRegistration',
    AutomaticScheduling = 'AutomaticScheduling'
}
